import { Component, Input, OnInit } from '@angular/core';
import { CategoryModalComponent } from '../category-modal/category-modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/app/lib/services/common.service';
import { StorageService } from 'src/app/lib/services/storage.service';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { CatalogueService } from 'src/app/lib/services/catalouge.service';

@Component({
    selector: 'app-request-new-product',
    templateUrl: './request-new-product.component.html',
    styleUrls: ['./request-new-product.component.scss'],
    standalone: false
})
export class RequestNewProductComponent implements OnInit {
  requestForm: FormGroup;
  selectedCategoryImage: any;
  submittedForms: any[] = [];
  userProfileURL: string;
  selectedImagePreview: any;
  imagePreview: { [key: string]: string | ArrayBuffer | null } = {};
  @Input() retailerName: string;
  constructor(
    private catalogueService: CatalogueService,
    public commonService: CommonService,
    private router: Router,
    private fb: FormBuilder,
    private modalController: ModalController,
    public storage: StorageService
  ) { }

  ngOnInit() {
    this.requestForm = this.fb.group({
      category: ['', Validators.required],
      productName: ['', Validators.required],
      description: [''],
      productImage: [''],
    });
  }


  async onSubmit() {
    if (this.requestForm.valid) {
      const retailerId = this.commonService.getUserData().userId;
      const shopId = this.commonService.getUserData().shopId;
      const retailerNumber = this.commonService.getUserData().phone;
        this.commonService.presentProgressBarLoading();
       
        const { value: { category, productName, description, productImage } } = this.requestForm;
        const productData = {
          productImage: productImage,
          description: description,
          productName: productName,
          category: category,
          shopId: shopId,
          retailerId: retailerId,
          retailerName: this.retailerName,
          retailerNumber: retailerNumber,
        };

        // Push the product data object to the submittedForms array
        this.submittedForms.push(productData);

        // Convert each productData object to FormData when submitting
          const formData = new FormData();
          Object.entries(productData).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              if (value instanceof Blob) {
                formData.append(key, value);
              } else {
                formData.append(key, value as string);
              }
            }
          });

          // Handle product submission
          this.catalogueService.addProduct(formData).subscribe(async (res: any) => {
            // Only execute this if the product is added successfully
            if (res.success) {
              this.selectedCategoryImage = '';
              this.imagePreview = {};
              this.requestForm.reset();

              // Success modal presentation
              const successModal = await this.modalController.create({
                component: SuccessModalComponent,
                cssClass: ['SuccessModalComponent-component-css']
              });
              await successModal.present();
              // Automatically dismiss the modal after 3 seconds
              setTimeout(() => {
                successModal.dismiss();
              }, 1000);
            }
          }, (error: any) => {
            console.error(error);
            this.handleError(error.error.error.message);
          });
     
    }
  }

  moveToCatalog() {
    this.router.navigate(['/my-catalog']);
    this.modalController.dismiss();
  }

  // Centralized error handling function
  async handleError(error: any) {
    this.commonService.danger(error);
  }

  onFileSelected(event: any, controlName: string) {
    const file = event.target.files[0];
    this.requestForm.get(controlName)?.setValue(file);
    this.previewFile(file, controlName);
  }

  private previewFile(file: File, controlName: string) {
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview[controlName] = reader.result;
      };
      reader.readAsDataURL(file);
      this.requestForm[controlName] = file;
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  onCategoriesSelected(selectedCategories: any[]) {
    if (selectedCategories.length > 0) {
      this.requestForm.patchValue({ category: selectedCategories[0].name });
      this.selectedCategoryImage = selectedCategories[0].image;
    }
  }

  async openSelectCategoryModal() {
    const modal = await this.modalController.create({
      component: CategoryModalComponent
    });

    modal.onDidDismiss().then((data) => {
      if (data.data && data.data.selectedCategories) {
        this.onCategoriesSelected(data.data.selectedCategories);
      }
    });

    return await modal.present();
  }

}
